module.exports = __webpack_public_path__ + "img/user_avatar.129d6322.png";